export const LOCALE = {
  RU: 'ru',
  KG: 'ky',
};
